import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Main.css';
import useSEO from '../../hooks/useSEO';

import img_beitec from '../../assets/BEITEC_LOGO_SF.png';
import { FaCloud, FaMobileAlt, FaWifi, FaChartLine, FaBoxOpen, FaCashRegister, FaCreditCard, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { BsArrowRight } from 'react-icons/bs';

// Sector Images
import img_livraria_a from '../../assets/livraria_a.jpg';
import img_cafe from '../../assets/cafe.png';
import img_bar from '../../assets/bar.png';
import img_restaurante from '../../assets/restaurante.png';
import img_pet from '../../assets/petshop.png';
import img_clinica from '../../assets/clinica.png';
import img_roupas from '../../assets/roupas.png';
import img_servicos from '../../assets/servicos.png';
import img_fruteira from '../../assets/fruteira.png';
import img_mercado from '../../assets/mercado.png';
import img_geral from '../../assets/geral.png';
import img_distribuidora from '../../assets/distribuidora.png';

// Integrations Images
import img_stone from '../../assets/stone.png';
import img_vero from '../../assets/vero.png';
import img_pagSeg from '../../assets/pagseg.png';
import img_paygo from '../../assets/paygo-1.png';

const sectors = [
  { id: 'livraria', name: 'Livrarias', img: img_livraria_a, desc: 'Sistema de gestão em nuvem para livrarias e papelarias. Agilize suas operações com emissão de notas fiscais, gestão de estoque e pagamentos integrados. Venda e consulte o estoque offline, mesmo sem internet. Auto preenchimento de cadastro de livros e interface amigável para facilitar o uso. Suporte humano dedicado para te ajudar sempre que precisar. Experimente agora e transforme seu negócio!' },
  { id: 'cafe', name: 'Cafeterias', img: img_cafe, desc: 'Agilize sua cafeteria com nosso sistema em nuvem! Comanda eletrônica, impressão de pedidos, gestão de estoque, vendas online e offline, diversas opções de pagamento e muito mais. Interface amigável e suporte dedicado para o sucesso do seu negócio.' },
  { id: 'restaurante', name: 'Restaurantes', img: img_restaurante, desc: 'Agilize seu restaurante com nosso sistema inteligente. Gestão completa de pedidos para cozinha e bar, faturamento rápido, divisão de contas, controle rigoroso de insumos e fechamento de caixa simplificado.' },
  { id: 'bar', name: 'Bares', img: img_bar, desc: 'Agilize seu bar com nosso sistema em nuvem! Comanda eletrônica, impressão de pedidos em múltiplos setores, gestão de estoque, vendas online e offline, diversas opções de pagamento e controle absoluto de mesas.' },
  { id: 'vestuario', name: 'Vestuário', img: img_roupas, desc: 'Agilize a emissão de notas fiscais, controle o estoque de forma inteligente por grade de cor e tamanho, crie etiquetas com código de barras para vitrine, gerencie crediário e potencialize o atendimento da sua loja de roupas.' },
  { id: 'pet', name: 'Petshops', img: img_pet, desc: 'Cadastre pets com fotos e detalhes, agilize o atendimento de banho e tosa, emita notas, controle o estoque da sua loja pet, venda online e offline, e ofereça diversas opções de pagamento. Seu negócio mais profissional e organizado.' },
  { id: 'fruteira', name: 'Fruteiras', img: img_fruteira, desc: 'Agilize suas vendas! Integre balanças diretamente ao caixa. Emita notas fiscais, registre pesos com extrema rapidez, previna perdas controlando o estoque e gerencie a caderneta de clientes facilmente.' },
  { id: 'mercado', name: 'Mercados', img: img_mercado, desc: 'Frente de caixa ultra-rápida para mercados, mercearias e padarias! Integração nativa com TEF, leitores de código de barras rápidos e balanças. Simplifique a fila e aumente a produtividade de cada caixa.' },
  { id: 'clinica', name: 'Clínicas', img: img_clinica, desc: 'Sistema de gestão para clínicas e consultórios médicos. Organize seus atendimentos com total eficiência! Prontuários eletrônicos, agendamento ágil, emissão de notas de serviços (NFS-e) e controle financeiro avançado integrados.' },
  { id: 'servicos', name: 'Serviços', img: img_servicos, desc: 'A prestação perfeita! Emita notas de serviço, registre ordens de serviço (OS) técnicas, acesse de onde do celular e gerencie os prazos e o financeiro do seu negócio de forma simples, objetiva e muito eficaz.' },
  { id: 'distribuidora', name: 'Distribuição', img: img_distribuidora, desc: 'Controle atacadista com suporte à múltiplas tabelas de preços, emissão em lote, controle de boletos, pedidos robustos e agilidade ímpar no faturamento logístico da sua distribuidora.' },
  { id: 'geral', name: 'Varejo em Geral', img: img_geral, desc: 'Agilize suas vendas no dia a dia, gerencie o estoque, fidelize clientes e controle finanças com nosso sistema abrangente em nuvem. Compatível com dezenas de segmentos e de fácil implantação imediata.' }
];

export default function Main() {
  const [scrolled, setScrolled] = useState(false);
  const [activeSector, setActiveSector] = useState(sectors[0]);

  useSEO(
    'BeiTec - Gestão Inteligente para Pequenas e Médias Empresas',
    'A BeiTec resolve o que está te travando: vendas ágeis, estoque controlado, clientes fidelizados e decisões embasadas em dados. Conheça nossa solução em nuvem para diversos segmentos.'
  );

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openWhatsApp = () => {
    window.open("https://api.whatsapp.com/send?phone=555195555616", "_blank");
  };

  const handleNextSector = () => {
    const currentIndex = sectors.findIndex(s => s.id === activeSector.id);
    const nextIndex = (currentIndex + 1) % sectors.length;
    setActiveSector(sectors[nextIndex]);
  };

  const handlePrevSector = () => {
    const currentIndex = sectors.findIndex(s => s.id === activeSector.id);
    const prevIndex = (currentIndex - 1 + sectors.length) % sectors.length;
    setActiveSector(sectors[prevIndex]);
  };

  return (
    <div className="main-container">
      {/* Navbar */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-content">
          <img src={img_beitec} alt="BeiTec Sistemas" className="nav-logo" />
          <div className="nav-links">
            <a href="#integracoes">Integrações</a>
            <a href="#solucoes">Soluções</a>
            <a href="#setores">Para Seu Setor</a>
            <a href="#sobre">Sobre Nós</a>
            <button className="nav-btn" onClick={openWhatsApp}>Fale com um consultor</button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background"></div>
        <div className="hero-content">
          <h1 className="hero-title"><span className="highlight">Mais Controle, <br />Menos Complicação</span></h1>
          <p className="hero-subtitle">
            A BeiTec resolve o que está te travando: vendas ágeis, estoque controlado, clientes fidelizados e decisões embasadas em dados. Simples. Leve. Feito para você crescer.
          </p>
          <div className="hero-actions">
            <button className="btn-primary" onClick={openWhatsApp}>
              Ative o Controle Total <BsArrowRight className="icon-right" />
            </button>
            <button className="btn-secondary" onClick={() => {
              const el = document.getElementById('integracoes');
              if (el) el.scrollIntoView();
            }}>
              Ver Vantagens
            </button>
          </div>
        </div>
      </section>

      {/* Integrations Section */}
      <section id="integracoes" className="integrations-section">
        <div className="section-header">
          <h2>Somos parceiros e integrados<br /><span className="highlight">diretamente com as smarts</span></h2>
          <p>Conectividade fluida com as principais máquinas e institutições de pagamento do mercado financeiro.</p>
        </div>
        <div className="integrations-grid">
          <div className="integration-card"><img src={img_stone} alt="Stone" /></div>
          <div className="integration-card"><img src={img_vero} alt="Vero" /></div>
          <div className="integration-card"><img src={img_pagSeg} alt="PagSeguro" /></div>
          <div className="integration-card"><img src={img_paygo} alt="PayGo" /></div>

          {/* Styled text blocks for missing logo files to maintain visual harmony */}
          <div className="integration-card text-brand" style={{ color: '#32a852' }}>Sicredi</div>
          <div className="integration-card text-brand" style={{ color: '#005baa' }}>Banrisul</div>
          <div className="integration-card text-brand" style={{ color: '#005ca9' }}>Caixa</div>
          <div className="integration-card text-brand" style={{ color: '#009ee3' }}>Mercado Pago</div>
          <div className="integration-card text-brand" style={{ color: '#ff7a00' }}>Inter</div>
          <div className="integration-card text-brand" style={{ color: '#333333' }}>SiTef</div>
        </div>
      </section>

      {/* NFE Section */}
      <section className="nfe-section">
        <div className="section-header">
          <h2>Emita Notas Fiscais <br /><span className="highlight">com Facilidade</span></h2>
          <p>Total conformidade fiscal para o seu negócio sem burocracia e com o mínimo de cliques possíveis.</p>
        </div>
        <div className="nfe-grid">
          <div className="nfe-card">
            <div className="nfe-badge">NF-e</div>
            <h3>Nota Fiscal Eletrônica</h3>
            <p>Emissão ágil para venda de produtos, remessas, distribuição e completo faturamento B2B do estabelecimento.</p>
          </div>
          <div className="nfe-card">
            <div className="nfe-badge">NFC-e / CF-e</div>
            <h3>Consumidor & Cupom</h3>
            <p>Emissão contínua super rápida para o consumidor em sua frente de caixa, perfeitamente integrada aos seus PDVs.</p>
          </div>
          <div className="nfe-card">
            <div className="nfe-badge">NFS-e</div>
            <h3>Nota de Serviço</h3>
            <p>Módulo fiscal dedicado à sua prestação de serviços. Integre sua Clínica, Oficina ou Consultoria sem dores de cabeça.</p>
          </div>
        </div>
      </section>

      {/* Setores Carousel Section */}
      <section id="setores" className="sectors-section">
        <div className="section-header">
          <h2>Atendemos Múltiplos <span className="highlight">Modelos de Negócios</span></h2>
          <p>Feito sob medida para os requisitos indispensáveis da sua operação diária.</p>
        </div>
        <div className="sector-showcase">
          <div className="sector-main-banner" style={{ backgroundImage: `url(${activeSector.img})` }}>
            <div className="sector-overlay">
              <h3>{activeSector.name}</h3>
              <p>{activeSector.desc}</p>
              <button className="btn-primary small" onClick={openWhatsApp}>Experimente no seu Negócio</button>
            </div>
            {/* Arrows for Desktop/Mobile navigation inside main image */}
            <button className="sector-arrow prev" onClick={handlePrevSector}><FaChevronLeft /></button>
            <button className="sector-arrow next" onClick={handleNextSector}><FaChevronRight /></button>
          </div>

          <div className="sector-thumbnails-container">
            {sectors.map((sec) => (
              <div
                key={sec.id}
                className={`sector-thumb ${sec.id === activeSector.id ? 'active' : ''}`}
                onClick={() => setActiveSector(sec)}
              >
                <img src={sec.img} alt={sec.name} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section id="solucoes" className="features-section">
        <div className="section-header">
          <h2>Soluções Completas para seu Negócio</h2>
          <p>Tudo o que você precisa em uma única plataforma robusta.</p>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon"><FaChartLine /></div>
            <h3>Gestão Empresarial Integrada</h3>
            <p>Tenha uma visão abrangente das operações, facilitando a tomada de decisões estratégicas com dashboards customizados e avançados.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><FaCashRegister /></div>
            <h3>Frente de Caixa (PDV)</h3>
            <p>Um sistema prático e intuitivo para ter mais agilidade na hora de atender os clientes e evitar filas na sua loja.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><FaBoxOpen /></div>
            <h3>Gestão de Estoques</h3>
            <p>Visualize, controle e organize seu estoque em tempo real. Cadastro relacional de produtos rápido e totalmente descomplicado.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><FaCreditCard /></div>
            <h3>Pagamentos Integrados</h3>
            <p>Praticidade e segurança nas transações. Compatível com legislações regionais incluindo TEF ou SMART-TEF Integrado.</p>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section id="passos" className="steps-section">
        <div className="steps-container">
          <div className="steps-text">
            <h2>Ative o Controle Total em <br /><span className="highlight">3 Passos Simples</span></h2>
            <p>Deixe a burocracia de lado e foque no sucesso da sua empresa. Nosso processo de implantação é ágil e direto ao ponto.</p>
          </div>
          <div className="steps-list">
            <div className="step-item">
              <div className="step-number">1</div>
              <div className="step-info">
                <h4>Mapeamos e Integramos</h4>
                <p>Conectamos seu estoque, vendas e clientes em um único sistema, unindo todos os pilares em um só lugar.</p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-number">2</div>
              <div className="step-info">
                <h4>Automatizamos a Gestão</h4>
                <p>Automação e dashboards customizados às suas necessidades. Relatórios ricos e rápidos.</p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-number">3</div>
              <div className="step-info">
                <h4>Você Cresce Mais Rápido</h4>
                <p>Decisões baseadas em dados. Menos tarefas manuais operacionais. Escala e mais resultados garantidos.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cross-Platform Section */}
      <section className="platform-section">
        <div className="section-header">
          <h2>Funciona Onde e Quando <span className="highlight">Você Precisar</span></h2>
          <p>Integração fluida nos mais variados dispositivos do seu negócio</p>
        </div>
        <div className="platform-grid">
          <div className="platform-card">
            <div className="plat-icon"><FaWifi /></div>
            <h3>Recursos Offline</h3>
            <p>Faça vendas, consulte valores, cadastros e estoque, mesmo sem internet. Seus dados são sincronizados automaticamente ao voltar a conexão.</p>
          </div>
          <div className="platform-card">
            <div className="plat-icon"><FaMobileAlt /></div>
            <h3>Multiplataforma</h3>
            <p>PC, tablet ou celular, você tem acesso total ao seu negócio de onde estiver. Liberdade e total flexibilidade para a sua rotina.</p>
          </div>
          <div className="platform-card">
            <div className="plat-icon"><FaCloud /></div>
            <h3>Tecnologia Cloud</h3>
            <p>Alta segurança e estabilidade com backups automáticos, garantindo que sua operação nunca pare e seus dados fiquem sempre protegidos e íntegros.</p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="sobre" className="about-section">
        <div className="about-content">
          <div className="about-text">
            <h2>Nascida para <span className="highlight">Resolver e Crescer</span></h2>
            <p>A BeiTec nasceu de uma necessidade real e um local inesperado: dentro de uma livraria. Começamos com funções simples, mas essenciais, para resolver os desafios reais do dia a dia: gerenciar vendas, estoque, pedidos e o relacionamento com o cliente. Essa experiência imersiva no varejo nos deu uma base sólida inquebrável.</p>
            <p>Temos convicção que a melhor solução é aquela que é prática, muito robusta e feita para funcionar sem atritos com o seu caixa.</p>
            <p>Hoje, nossa visão está expandida e atendemos uma ampla gama de setores. O negócio cresceu para abraçar e alavancar a sua operação.</p>
          </div>
          <div className="about-stats">
            <div className="stat-box">
              <h3>+12</h3>
              <p>Anos de Experiência</p>
            </div>
            <div className="stat-box">
              <h3>100%</h3>
              <p>Foco em Simplicidade</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-container">
          <h2>Pronto Para Controlar Sua Gestão e Crescer?</h2>
          <p>Invista 15 minutos do seu tempo para descobrir como a BeiTec transforma seu negócio. Sem complicação. Apenas um sistema que entrega o que promete.</p>
          <button className="btn-primary large" onClick={openWhatsApp}>
            Fale com nosso consultor agora
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={img_beitec} alt="BeiTec Sistemas" />
            <p>A mais de uma década inovando negócios com uma tecnologia acessível, moderna e inteligente.</p>
          </div>
          <div className="footer-links">
            <h4>Produto</h4>
            <a href="#solucoes">Soluções Avançadas</a>
            <a href="#passos">A Implantação</a>
            <a href="#setores">Casos Práticos</a>
          </div>
          <div className="footer-contact">
            <h4>Contato Direto</h4>
            <p>WhatsApp: (51) 9555-5616</p>
            <p>Suporte e Vendas</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} BeiTec ® Sistemas. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
}
